<template>
  <CDropdown
    inNav
    class="c-header-nav-items header-dropdown"
    placement="bottom-end"
    add-menu-classes="pt-0"
    :class="{ 'pb-0': !hasNotifications }"
    :show.sync="show"
  >
    <CDropdownHeader
      tag="div"
      class="text-center"
      color="light"
    > 
      <template v-if="hasNotifications">
        <strong>You have {{ unreadedNotifications }} notifications</strong>
        <div class="heading">
          <button 
            class="mark-all btn btn-link" 
            @click="readAll"
          >Mark all as read</button>
        </div>
      </template>
      <strong v-else>You don't have any notifications</strong>
    </CDropdownHeader>
    <template #toggler>
      <CHeaderNavLink>
        <CIcon name="cil-bell"/>
        <CBadge v-if="hasNotifications" color="danger">{{ unreadedNotifications }}</CBadge>
      </CHeaderNavLink>
    </template>

    <CDropdownItem
      v-for="notification in notifications"
      :key="notification.id"
      :notification="notification"
      class="notifications notification-menu"
    >
      <VNotificationListItem
        class="notification-menu__item"
        :notification="notification"
      />
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { createAuthStoreMixin, authStore } from '@/mixins/authStoreMixin'
import VNotificationListItem from '@/components/NotificationList/VNotificationListItem'

export default {
  name: 'TheHeaderDropdownAccnt',

  components: {
    VNotificationListItem
  },

  mixins: [
    createAuthStoreMixin()
  ],

  computed: {
    currentUser () {
      return this[authStore.getterTypes.GETTER_USER]
    },
    notifications () {
      return this[authStore.getterTypes.GETTER_NOTIFICATIONS]
    },
    unreadedNotificationCount () {
      return this[authStore.getterTypes.GETTER_UNREADED_NOTIFICATIONS_COUNT]
    },
    unreadedNotifications () {
      return this.unreadedNotificationCount > 99 ? '99+' : this.unreadedNotificationCount
    },
    hasNotifications () {
      return this.unreadedNotificationCount > 0
    }
  },

  data: () => ({
    show: false
  }),

  methods: {
    readAll() {
      this[authStore.actionTypes.ACTION_READ_ALL_NOTIFICAITONS]()
      this.show = false
    }
  }
}
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}

.mark-all {
  padding: 0;
}
</style>
